<template>
  <div class="createNewStory">
    <v-container v-if="refreshQuotes==true" class="mt-16 pt-16 mb-0 pb-0 px-0">
      <v-row v-show="isToggleKG!=true" class="mt-2 pt-0 mb-0 px-4 pb-0" align="center">
        <v-col cols="12" align="left" class="mt-0 pt-0 mb-0 pb-0">
          {{$t('location')}}
        </v-col>
        <v-col cols="12" align="left" class="mt-0 pt-0 mb-0 pb-0">
          <createNewStoryAddLocationContent />
        </v-col>
      </v-row>
      <v-row v-show="isToggleKG!=true" class="mt-0 pt-0 mb-0 pb-0 px-4">
        <v-col cols="12" class="mt-0 pt-0 mb-0 pb-0">
          {{$t('storyTitle')}}
        </v-col>
        <v-col cols="12" class="mt-0 pt-0 mb-2 pb-4">
          <v-text-field :rules="[v => (v || '' ).length >= 4 || $t('TitleRule')]" prepend-icon="edit"
            v-model="cache.storyTitle" @change="saveCurrentStory" hide-details="auto">
          </v-text-field>
        </v-col>
      </v-row>
      <v-row align="center" justify="center" class="px-4" v-show="isToggleKG!=true">
        <v-col align="center" justify="center" cols=12>
          <uploadMediaCoverImage />
        </v-col>
      </v-row>
      <v-row align="center" justify="center" class="" v-show="isToggleKG!=true">
        <v-col align="center" justify="center" cols=12>
          <uploadMedia />
        </v-col>
      </v-row>
      <v-row v-show="isToggleKG!=true" class="px-2">
        <v-col>
          <swiper class="swiper" :options="swiperOption">
            <swiper-slide v-for="(item,i) in KgOnlyImageSelected" :key="item.id">
              <v-img :src="item.image" :lazy-src="item.image">
                <v-btn @click="removeImage(i)" class="deletecovericon" color="red" dark small right fab>
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-img>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </v-col>
      </v-row>
      <v-row v-show="isToggleKG!=true&&refreshComponentKG==true" class="px-4">
        <span class="yourStoryLabel px-4">{{$t('yourStory')}}</span>
        <v-col v-for="(item,index) in cache.content" :key="index" cols="12" class="mt-0 pt-0 mb-4 px-4">
          <v-row>
            <v-col align="left" cols="3">
              <v-btn text color="primary" @click="editContentBlock(index)">
                <v-icon v-if="item.toggle">mdi-pen-lock</v-icon>
                <v-icon v-else>mdi-pen</v-icon>
              </v-btn>
            </v-col>
            <v-col align="center" cols="3">
              <v-btn v-if="index<cache.content.length-1" text color="primary" @click="swapContentBlock(index,index+1)">
                <v-icon>mdi-arrow-down-bold</v-icon>
              </v-btn>
            </v-col>
            <v-col align="center" cols="3">
              <v-btn v-if="index>0" text color="primary" @click="swapContentBlock(index,index-1)">
                <v-icon>mdi-arrow-up-bold</v-icon>
              </v-btn>
            </v-col>
            <v-col align="right" cols="3">
              <v-btn v-if="cache.content.length-1>0" text color="primary" @click="removeContentBlock(index)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <wysiwyg v-if="item.toggle" class="editorstyle" v-model="item.data" :locale="$i18n.locale" />
          <span v-else v-html="item.data" />
          <v-divider v-if="cache.content.length>1" style="margin-top:5%"></v-divider>
        </v-col>
      </v-row>
      <v-row color="complementaryVariant" v-show="isToggleKG==true&&refreshComponentKG==true" class="px-2">
        <v-container class="elevation-4 px-4 fill-height">
          <v-row class=" px-2 mt-16 minheightSuggestion" v-if="isOnlyImageFromKG">
            <v-col v-show="isToggleKG==true&&refreshComponentKG==true&isOnlyImageFromKG" cols=12 class="mx-2 pt-10">
              <strong>{{$t('KgOnlyImageResultsLength',[onlyKGImageResultsLength])}}</strong>
            </v-col>
            <v-col class="text-center "
              v-if="(typeof searchKGKeyword =='string'&&searchKGKeyword!='')&&KgOnlyImageResults.length==0">
              {{$t("noDataText")}}
            </v-col>
            <v-col v-else cols="6" v-for="(singleKgInformation) in KgOnlyImageResults" :key="singleKgInformation.id">
              <v-img @click="addSelectKGPreferencesOnlyImg(singleKgInformation)" v-if="singleKgInformation.image"
                :src="singleKgInformation.image" :lazy-src="singleKgInformation.image">
                <v-overlay :value="arrayOnlyImageIDselectedStory.indexOf(singleKgInformation.id) > -1" absolute>
                  <v-icon>mdi-check-bold</v-icon>
                </v-overlay>
              </v-img>
              <p>{{singleKgInformation.label}}</p>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" v-else class="minheightSuggestion">
            <v-col v-show="isToggleKG==true&&refreshComponentKG==true&!isOnlyImageFromKG" cols=12 class="mx-2 pt-10">
              <strong>{{$t('KgOnlyTextResultsLength',[onlyKGTextResultsLength])}}</strong>
            </v-col>
            <v-col class="text-center"
              v-if="(typeof searchKGKeyword =='string')&&KgOnlyTextResults.length==0">
              {{$t("noDataText")}}
            </v-col>
            <template v-else>
              <v-col cols="8" class="elevation-4 mt-4 px-2 mx-4 text-center"
                v-for="(singleKgInformation) in KgOnlyTextResults" :key="singleKgInformation.description">
                <p v-if="singleKgInformation.description!=''">{{singleKgInformation.label}} :
                  {{singleKgInformation.description}} </p>
                <p v-else>{{singleKgInformation.label}}</p>
                <v-btn color="primaryVariant" class="addKGOnlyTextBtn mt-2"
                  @click="selectKGPreferencesOnlyText(singleKgInformation)">{{$t("addToStory")}}</v-btn>
              </v-col>
            </template>
          </v-row>
        </v-container>
      </v-row>
      <v-row v-show="isToggleKG!=true&&cache.content.length>1" class="px-4">
        <v-col align="right" cols="12">
          <v-btn text color="primary" @click="addContentElement()">
            <v-icon>mdi-plus-thick</v-icon>
            <v-icon>mdi-note-text</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-show="isToggleKG!=true&&sortContentBlock==true&&sortContentBlock==true" class="px-4">
        <v-col v-if="cache.content.length>1" cols="12" style="mb-5"><strong>{{ $t("Sources")}}</strong></v-col>
        <v-col cols="12" class="mt-0 pt-0 mb-4 px-0">
          <ul>
            <span v-for="(item) in cache.content" :key="item.id">
              <li v-if="item.type=='quote'"><a v-if="item.data!='content'" :href="item.url"
                  target="_Blank">{{item.url}}</a>
              </li>
            </span>
          </ul>
        </v-col>
      </v-row>
      <v-footer color="white" v-show="isToggleKG!=true" :min-height="50" :fixed="true" :app="true"
        class="maxwidth mt-0 pt-0 mb-0 pb-0">
        <v-container fill-height fluid class="mt-0 pt-0 mb-0 pb-0 px-2">
          <v-row>
            <v-col cols="10">
            </v-col>
            <v-col cols="2">
              <v-btn @click="goToPublish()" color="primaryVariant" fab small>
                <v-icon>mdi-check-bold</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-footer>
    </v-container>
    <v-dialog v-model="dialogSaveBeforeExit" hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialogSaveBeforeExit = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-actions>
          <v-row align=center justify=center>
            <v-col cols=10>
              <span class="beforeLeaveCreate">{{$t('beforeLeaveCreate')}}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-center" cols=12>
              <btnDraftOrPublish color="green darken-1" :isDialogBeforeLeaveCreate="true" />
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  Swiper,
  SwiperSlide
} from 'vue-awesome-swiper'
import 'swiper/swiper.min.css'

import uploadMediaCoverImage from "@/components/uploadMediaCoverImage.vue"
import btnDraftOrPublish from "@/components/btnDraftOrPublish.vue"
import uploadMedia from "@/components/uploadMedia.vue";
import createNewStoryAddLocationContent from "@/components/createOrEditStory/addLocationContent.vue"
export default {
  name: "createNewStoryContent",
  components: {
    Swiper,
    SwiperSlide,
    uploadMedia,
    createNewStoryAddLocationContent,
    btnDraftOrPublish,
    uploadMediaCoverImage

  },
  data: () => ({
    imageArray: [],
    sortContentBlock: true,
    refreshQuotes: true,
    refreshComponentKG: true,
    // [] id array selected item
    KGselectedOnlyImage: [],
    //isToggleKG:false,
    apiUrl: process.env.VUE_APP_ROOT_API,
    userLocation: null,
    //mock data of a search keyword in db
    KgOnlyImageResults: [],
    KgOnlyTextResults: [],
    KgOnlyImageSelected: [],
    arrayOnlyImageIDselectedStory: [],
    swiperOption: {
      slidesPerView: 2.4,
      spaceBetween: 5,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    }
  }),

  mounted() {
    this.$store.dispatch("setDialogSaveBeforeExit", "")
    this.$store.dispatch('setIsSuggestionLoading', false)
    this.initializingEditor()

    if (typeof this.cache.KGselectedOnlyImage == Array && this.cache.KGselectedOnlyImage.length > 0) {
      this.KgOnlyImageSelected = this.cache.KGselectedOnlyImage
    }

    // edit story with content
    //becouse in the next page there is show hide button
    this.$store.dispatch("setIsEditTitleAndMapStory", true)
  },
  computed: {
    onlyKGImageResultsLength: {
      get: function () {
        return this.KgOnlyImageResults.length
      }
    },
    onlyKGTextResultsLength: {
      get: function () {
        return this.KgOnlyTextResults.length
      }
    },
    searchKGKeyword: {
      get: function () {
        return this.$store.getters.getSuggestionSearchText
      }
    },
    isOnlyImageFromKG: {
      get: function () {
        return this.$store.getters.getIsToggleSuggestionOnlyImageEnable
      }
    },
    isToggleKG: {
      get: function () {
        return this.$store.getters.getIsToggleSuggestionEnable;
      }
    },
    arrayOnlyImageIDselectedStoryLength: {
      get: function () {
        return this.arrayOnlyImageIDselectedStory.length
      }
    },
    dialogSaveBeforeExit: {
      get: function () {
        return this.$store.state.dialogSaveBeforeExit
      },
      set: function (newValue) {
        this.$store.dispatch("setDialogSaveBeforeExit", newValue)
      }
    },
    cache: {
      get: function () {
        return this.$store.state.newStories
      }
    }
  },
  watch: {
    '$store.state.isSuggestionLoading': function () {
      if (this.$store.state.isSuggestionLoading == true)
        this.setSearchKG(this.searchKGKeyword)

    },
  },
  methods: {
    swapContentBlock(index, index2) {
      this.sortContentBlock = false
      let temp = this.cache.content[index]
      this.cache.content[index] = this.cache.content[index2]
      this.cache.content[index2] = temp
      this.sortContentBlock = true
    },
    removeImage(i) {
      this.KgOnlyImageSelected.splice(i, 1)
    },
    initializingEditor() {

      //INITIALIZING array of wysiwyg
      //new story or edit story with no content
      let outcome

      try {
        outcome = JSON.parse(this.cache.content)
      } catch (err) {
        outcome = false
      }
      if (outcome != false && this.cache.content != []) {
        this.$store.dispatch("updateContent", JSON.parse(this.cache.content))
      } else if (this.cache.content.length == 0)
        this.$store.dispatch("updateContent", [{
          "data": "", // il mio content è html
          "toggle": true, // devo eliminare il toggle prima di salvare l'oggetto 
          "url": null, // se è un quote,
          "type": "custom" //quote or custom
        }])
      else {
        if (typeof this.cache.content != "object")
          this.$store.dispatch("updateContent", [{
            "data": this.cache.content, // il mio content è html
            "toggle": true, // devo eliminare il toggle prima di salvare l'oggetto 
            "url": null, // se è un quote,
            "type": "custom" //quote or custom
          }])
      }
    },
    editContentBlock(index) {
      this.refreshComponentKG = false
      this.cache.content[index].toggle = !this.cache.content[index].toggle
      this.refreshComponentKG = true

    },
    addContentElement() {
      this.cache.content.push({
        data: '',
        toggle: false,
        url: null,
        type: "custom"
      })
    },
    removeContentBlock(index) {
      this.cache.content.splice(index, 1)
    },
    //extract all image from KGonlyimage

    processKgOnlyImageResults() {
      //console.log("----KgOnlyImageResults",this.KgOnlyImageResults)
      this.imageArray = []

      /*
            this.KgOnlyImageResults.forEach(firstlevel => {
              if (firstlevel.additional_info.length>0) {
                firstlevel.additional_info.forEach(secondlevel =>{
                  if(secondlevel.image!=""&&secondlevel.image!=null){
                    this.imageArray.push(secondlevel)
                  }
                })
              }
            });
      */

    },

    addSelectKGPreferencesOnlyImg(item) {
      if (this.arrayOnlyImageIDselectedStory.indexOf(item.id) > -1) {
        //i have to remove item
        this.KgOnlyImageSelected.forEach((element, index) => {
          console.log(element);
          if (item.id == element.id) {
            this.KgOnlyImageSelected.splice(index, 1)
            this.arrayOnlyImageIDselectedStory = this.KgOnlyImageSelected.map(single => single.id);
          }
        });
      } else {
        //add item image
        this.KgOnlyImageSelected.push(item)
        this.arrayOnlyImageIDselectedStory = this.KgOnlyImageSelected.map(single => single.id);
      }
    },

    //to delete this method
    removeSelectKGPreferencesOnlyImg(itemID) {
      //console.log("itemID",itemID)
      this.KgOnlyImageSelected.forEach((element, index) => {

        if (itemID == element.id) {
          this.KgOnlyImageSelected.splice(index, 1)
          this.arrayOnlyImageIDselectedStory = this.KgOnlyImageSelected.map(single => single.id);
        }
      });
      this.KgOnlyImageSelected.forEach

    },

    //  remove

    selectKGPreferencesOnlyText(selectedObject) {

      //check if quote is already in content
      if (selectedObject.selected != true) {
        //this.cache.content=this.cache.content+"<div disabled=true id="+selectedObject.id.toString().concat('-text')+"><br/>"+"<em>"+selectedObject.text+"</em></div>"
        selectedObject.toggle = false
        if (selectedObject.content != '') {
          this.cache.content.push({
            "id": selectedObject.id,
            "data": selectedObject.description, // il mio content è html
            "toggle": false, // devo eliminare il toggle prima di salvare l'oggetto 
            "url": 'https://www.wikidata.org/wiki/' + selectedObject.id, // se è un quote,
            "type": "quote" //quote or custom
          })
          this.$store.dispatch("setSnackbar", {
            color: 'green',
            text: selectedObject.description,
            active: true
          })
        } else {
          this.cache.content.push({
            "id": selectedObject.id,
            "data": selectedObject.label, // il mio content è html
            "toggle": false, // devo eliminare il toggle prima di salvare l'oggetto 
            "url": 'https://www.wikidata.org/wiki/' + selectedObject.id, // se è un quote,
            "type": "quote" //quote or custom
          })
          this.$store.dispatch("setSnackbar", {
            color: 'green',
            text: selectedObject.label,
            active: true
          })
        }

      }
      this.refreshComponent = false
      this.KgOnlyTextResults.forEach((item, i) => {
        if (item.id == selectedObject.id) {
          this.KgOnlyTextResults[i].selected = !this.KgOnlyTextResults[i].selected
        }
        if (this.KgOnlyTextResults[i].selected == true) {
          this.KgOnlyTextResults[i].toggle = false
          this.KgOnlyTextSelected.push(this.KgOnlyTextResults[i])
        }
      })
      this.refreshComponent = true
    },

    selectKGPreferencesOnlyImg(selectedID) {
      this.KGselectedOnlyImage = []
      this.refreshComponent = false
      this.KgOnlyImageResults.forEach((item, i) => {
        if (item.id == selectedID) {
          this.KgOnlyImageResults[i].selected = !this.KgOnlyImageResults[i].selected
        }
        if (this.KgOnlyImageResults[i].selected == true) {
          this.KGselectedOnlyImage.push(this.KgOnlyImageResults[i])
        }
      })
      this.refreshComponent = true
    },

    async setSearchKG(value) {
      try {
        this.$store.dispatch('setIsSuggestionLoading', true)
        this.KgOnlyTextResults = []
        this.KgOnlyImageResults = []

        let tempKgResponseList
        tempKgResponseList = await this.getaxiosResponse(this.apiUrl + "/getKGResponse?keywords=" + value + "&algorithm=exact&language=" + this.$vuetify.lang.current + '&latitude=' + this.cache.marker.lat + '&longitude=' + this.cache.marker.lng + '&limit=30')

        // modificare in cliclo for
        tempKgResponseList.data.forEach(item => {

          if (typeof item.images != 'undefined')
            item.images.forEach(image => {
              image.label = item.label,
                this.KgOnlyImageResults.push(image)
            })
          if (typeof item.descriptions != 'undefined')
            item.descriptions.forEach(description => this.KgOnlyTextResults.push(description))
        })

        this.KgOnlyImageResults = this.KgOnlyImageResults.reduce((unique, o) => {
          if (!unique.some(obj => obj.id === o.id && obj.image === o.image)) {
            unique.push(o);
          }
          return unique;
        }, []);

        this.processKgOnlyImageResults()

        this.$store.dispatch('setIsSuggestionLoading', false)

      } catch (error) {
        this.$store.dispatch('setIsSuggestionLoading', false)
        console.log(error);
      }
    },
    back: function () {
      this.$store.dispatch("setDialogSaveBeforeExit", true)
    },
    goToHome: function () {
      this.$store.dispatch("clearNewStory")
      this.$indexdb.mediaFiles.clear()
      this.$store.dispatch("setDialogSaveBeforeExit", false)
      this.$router.push({
        name: 'home'
      })
    },
    saveCurrentStory: async function () {
      return this.$store.dispatch("setNewStories", {
        ...this.cache
      })
    },
    goToPublish: function () {
      this.saveCurrentStory().then(function () {
        this.cache.KGArrayImg = this.KgOnlyImageSelected
        this.cache.KGArrayText = this.KgOnlyTextSelected
        this.$store.dispatch("setDialogSaveBeforeExit", false)
        this.$router.push('createNewStoryPublish')
      }.bind(this))
    },
    saveAndgoToHome: function () {
      this.saveCurrentStory().then(function () {
        this.$store.dispatch("setDialogSaveBeforeExit", false)
        this.$router.push({
          name: 'home'
        })
      }.bind(this))
    }
  }
}
</script>
<style scoped>
.v-text-field{
  margin-top: 0px;
  padding-top: 0px;
}
.yourStoryLabel{
  font-weight: bold;
}
.v-input__prepend-outer{
padding: 10rem;
}
.btnNext{
  border-radius: 9999rem;
  padding: 10%;
}
.v-responsive__content{
  width: 100%!important;
  object-fit: cover;
}
@import "~vue-wysiwyg-lite/dist/vueWysiwyg.css";
.addKGOnlyTextBtn.selected{
color:chocolate
}
.addKGOnlyTextBtn{
  border-radius: 999rem;
}
.addKGInfoBtn.selected{
  /*color: blue;*/
}
.addKGInfoBtn{
  border-radius: 999rem;
}
.createNewStory{
  max-width: 100%;
}
img{
  max-width: 100%;
}
.beforeLeaveCreate{
  font-weight: bold;
  font-size: 1.2rem;
}
.minheightSuggestion{
  min-height:70vh
}
</style>
